export default "__VITE_ASSET__DUS81Roo__"